export default __webpack_public_path__ + "static/media/noImageGray.954e1d88.png";